import { consoleAPI } from '@/providers/apis/console/console';
import { ImpersonateUsersModel } from '@/models/console/impersonate-users';

export  default {
    namespaced: true,

    state: {
        impersonateUsers : [],
    },

    mutations: {
        fetchImpersonateUser(state: any, users: ImpersonateUsersModel) {
            state.impersonateUsers = users;
        },
    },

    actions: {
        fetchImpersonateUser(context: any, params: any) {
            consoleAPI.getImpersonateUsersList(params).then((users) =>  {
                context.commit('fetchImpersonateUser', users);
            });
        },
    },

};
